import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../rootReducer';
import { createUser, editUser } from './form.thunks';
import { updateSectionAccessPermissions } from './updateSectionAccessPermissions.thunks';
import { Features, isFeatureEnabled } from '../../featureToggles/features';

export interface UserFormState {
  loading: boolean;
  error: string | null;
}

export const initialState: UserFormState = {
  error: null,
  loading: false
};

const getUserForm = (state: RootState): UserFormState => state.users.form;
const getUserFormLoading = (state: RootState): boolean => getUserForm(state).loading;
const getUserFormError = (state: RootState): string | null => getUserForm(state).error;

export const selectors = {
  getUserForm,
  getUserFormLoading,
  getUserFormError
};

export const extraReducers = {
  [createUser.pending.type]: (state: UserFormState): void => {
    state.loading = true;
    state.error = null;
  },
  [createUser.fulfilled.type]: (state: UserFormState): void => {
    state.loading = false;
  },
  [createUser.rejected.type]: (state: UserFormState, action: PayloadAction<string>): void => {
    state.loading = false;
    state.error = action.payload;
  },
  [editUser.pending.type]: (state: UserFormState): void => {
    state.loading = true;
    state.error = null;
  },
  [editUser.fulfilled.type]: (state: UserFormState): void => {
    state.loading = false;
  },
  [editUser.rejected.type]: (state: UserFormState, action: PayloadAction<string>): void => {
    state.loading = false;
    state.error = action.payload;
  },
  [updateSectionAccessPermissions.pending.type]: (state: UserFormState): void => {
    if (isFeatureEnabled(Features.SectionsPermissions)) {
      state.loading = true;
      state.error = null;
    }
  },
  [updateSectionAccessPermissions.fulfilled.type]: (state: UserFormState): void => {
    if (isFeatureEnabled(Features.SectionsPermissions)) {
      state.loading = false;
    }
  },
  [updateSectionAccessPermissions.rejected.type]: (state: UserFormState, action: PayloadAction<string>): void => {
    if (isFeatureEnabled(Features.SectionsPermissions)) {
      state.loading = false;
      state.error = action.payload;
    }
  }
};

const formSlice = createSlice({
  name: 'form',
  initialState,
  reducers: {},
  extraReducers
});

export default formSlice.reducer;

export const actions = formSlice.actions;
export const caseReducers = formSlice.caseReducers;
